import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const tileContainerCss = css`
  width: 100%;
`

export const tileContentCss = css`
  display: flex;
  flex-direction: column;
`

export const tileHeaderCss = css`
  display: flex;
`

export const actionCss = css`
  display: flex;
`

export const bankAccountsCss = css`
  display: flex;
  flex-direction: column;
  margin: var(--tri-space-200) 0;
`

export const bankInfoCss = css`
  flex-grow: 2;
`

export const bankAccountRowCss = css`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: var(--tri-space-200);
`

export const BankAccountName = styled.div`
  ${({ theme }) => theme.type.fieldLabel};
  flex-grow: 10;
  color: ${({ connected, theme }) => connected ? theme.colors.basic : theme.colors.neutralStrong};
`

export const bankAccountBalanceCss = ({ type }) => css`
  ${type.amount};
`

export const bankAccountToggleCss = css`
  margin-left: var(--tri-space-300);
`

export const imageContainerCss = css`
  margin-right: var(--tri-space-150);
  img {
    width: 36px;
    height: 36px;
  }
`

export const bankNameCss = ({ type }) => css`
  ${type.titleSmall};
`

export const bankStatusCss = ({ type }) => css`
  ${type.caption};
`

export const errorCss = ({ colors, type }) => css`
  ${type.caption};
  color: ${colors.danger};
`

export const fixLinkCss = ({ colors, type }) => css`
  ${type.caption};
  color: ${colors.danger};
  text-decoration: underline;
  margin-left: var(--tri-space-50);
  padding-bottom: var(--tri-space-50);
`
